var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"information"},[_c('div',{staticClass:"iconWrapper"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("info")])],1),_c('div',{staticClass:"infoText"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }